/**
 * Simple countdown component.
 * Create basic layout or init on any element.
 * Handles four groups of time: days, hours, minutes, seconds,
 */

const Counter = require('component-counter');
const q = require('queried');
const EventEmitter = require('events');

/**
 * Countdown class
 * @class
 */
class Countdown extends EventEmitter {
  constructor(el, options) {
    super();

    // init element reference
    this.el = el;
    this.el.classList.add('countdown');

    // get date
    if (options.date instanceof Date) {
      this.date = options.date;
    } else {
      this.date = new Date(options.date);
    }

    // create the item counters list
    this.counterGroups = [];

    // ensure groups in the content
    this.initGroup('days');
    this.initGroup('hours');
    this.initGroup('minutes');
    this.initGroup('seconds');

    // set up backtick
    this.update();

    this.interval = setInterval(() => {
      this.update();
    }, 1000);
  }

  /**
   * Init group within an countdown
   * @param  {String} groupName    Name of the group
   * @param  {Number} groupDivider Value used to calculate number of units from given in ms
   * @return {void}
   */
  initGroup(groupName) {
    const groupEl = q(`.countdown-${groupName}`, this.el);

    // if group isn't found, don't init it
    if (!groupEl) return;

    // init group so that it becomes a counter
    groupEl.innerHTML = '';
    const counter = new Counter(groupEl, {
      digitClass: 'countdown-digit',
    });

    // add the counter group to list of groups
    this.counterGroups.push({
      name: groupName,
      counter,
    });
  }

  /**
   * Rerender time groups according to the time left (called each second)
   * @return {void}
   */
  update() {
    if (this.isExpired()) return;

    const now = (new Date()).getTime();

    // calc date diff
    const dateDiff = Math.abs(this.date - now);

    // update each group diff, update
    const timeLeft = {};

    const secondsDiff = Math.floor(dateDiff / 1000);
    timeLeft.seconds = secondsDiff % 60;

    const minutesDiff = Math.floor(secondsDiff / 60);
    timeLeft.minutes = minutesDiff % 60;

    const hoursDiff = Math.floor(minutesDiff / 60);
    timeLeft.hours = hoursDiff % 24;

    const daysDiff = Math.floor(hoursDiff / 24);
    timeLeft.days = Math.min(daysDiff, 999);

    this.counterGroups.forEach((counterGroup) => {
      const valueLeft = timeLeft[counterGroup.name];
      const { counter } = counterGroup;

      // if more than 99 days left, draw three digits
      if (counterGroup.name == 'days') {
        // show days in case watching countdoun in real time
        if (valueLeft) {
          counter.el.removeAttribute('hidden');
          counter.el.nextElementSibling.removeAttribute('hidden');
        }

        if (valueLeft > 99) {
          counter.digits(3);
        } else {
          counter.digits(2);
        }
      }

      counter.update(valueLeft);
    });
  }

  /**
   * Check if event has expired
   * @return {boolean}
   */
  isExpired() {
    const now = new Date().getTime();
    if (now > this.date) {
      this.destroy();
      return true;
    }
    return false;
  }

  /**
   * Destroy ticking when event has expired in real time watching
   * @return {void}
   */
  destroy() {
    this.emit('expire');
    clearInterval(this.interval);
  }
}

module.exports = Countdown;
